<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-16"><a id="_idTextAnchor016"></a>Faces</h2>
<p class="Top-quote"><em class="italic _idGenCharOverride-1">‘He who prays must turn his eyes down and his heart up’.</em></p>
<p class="Top-quote-source">Rabbinic saying</p>
<p class="Verse-new">Faces signal </p>
<p class="Verse-main">where we’re at</p>
<p class="Verse-main">who we are:</p>
<p class="Verse-new">Level, face to face,</p>
<p class="Verse-main">abled and ablaze?</p>
<p class="Verse-new">Upturned, catching vision</p>
<p class="Verse-main">of some greater love?</p>
<p class="Verse-new">Or, downward,</p>
<p class="Verse-main">buried in our hands,</p>
<p class="Verse-main">heart-constricting grief</p>
<p class="Verse-main">darkness of a blinded</p>
<p class="Verse-main">sight?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-18.vue?474fc677